"use client";

import React, { useState, useRef } from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
const projects = [{
  id: 1,
  title: "Modern Infill Duplex",
  industry: "Residential",
  image: "https://distinct-macaw.10web.cloud/wp-content/uploads/2026/05/infill-duplex-3.webp?v=4bsi45gy1ce"
}, {
  id: 2,
  title: "Commercial / Industrial",
  industry: "Commercial",
  image: "https://distinct-macaw.10web.cloud/wp-content/uploads/2026/05/commercial-warehouse.jpg?v=fentxfoj1nr"
}, {
  id: 3,
  title: "Luxury Estate Portfolio",
  industry: "Investment",
  image: "https://distinct-macaw.10web.cloud/wp-content/uploads/2026/05/Screen-Shot-2026-05-26-at-10.56.48-AM.png?v=zh34x8f8ba"
}, {
  id: 4,
  title: "Urban Multi-Family",
  industry: "Development",
  image: "https://distinct-macaw.10web.cloud/wp-content/uploads/2026/05/CapitolHillExt2.webp?v=vnti3qq54w"
}, {
  id: 5,
  title: "Retail Plaza Strip\xA0",
  industry: "Commercial",
  image: "https://distinct-macaw.10web.cloud/wp-content/uploads/2026/05/retail-plaza.jpg?v=9a17rchg3uj"
}, {
  id: 6,
  title: "Auxiliary Garden Unit",
  industry: "Residential",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687293/img/contemporary_garden_suite_lorenzo.png"
}];
export default function FeaturedInfillProjects() {
  const sectionRef = useRef<HTMLElement>(null);
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const [isHovering, setIsHovering] = useState(false);
  const handleMouseMove = (e: React.MouseEvent) => {
    if (!sectionRef.current) return;
    const rect = sectionRef.current.getBoundingClientRect();
    setMousePos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };
  return <section data-section-id="221623" id="featured-infill-projects" ref={sectionRef} className="relative cursor-none overflow-hidden bg-background py-24 text-foreground md:py-32" onMouseMove={handleMouseMove} onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
      {}
      <div className={cn("pointer-events-none absolute left-0 top-0 z-50 flex h-24 w-24 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-lg bg-primary text-sm font-default font-bold tracking-widest text-primary-foreground opacity-0 transition-opacity duration-300 shadow-lg", isHovering && "opacity-100")} style={{
      transform: `translate(${mousePos.x}px, ${mousePos.y}px)`
    }}>
        VIEW
      </div>

      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 flex flex-col items-center text-center">
          <h2 className="font-default text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl text-primary">
            Featured Infill Projects
          </h2>
          <p className="mt-4 max-w-2xl text-lg font-default text-muted-foreground">A curated portfolio of high-value developments managed by Lorenzo Cabason, delivering efficiency, transperancy and investor returns.</p>
        </div>

        {}
        <div className="columns-1 gap-6 space-y-6 md:columns-2 lg:columns-3">
          {projects.map((project, i) => <div key={project.id} data-index={i} className="break-inside-avoid">
              <Link to="/InfillInvestmentPage" className="group block relative overflow-hidden rounded-md bg-muted shadow-md">
                <AspectRatio ratio={4 / 5}>
                  {}
                  <img src={project.image} alt={project.title} className="object-cover transition-transform duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] scale-110 group-hover:scale-100 group-hover:grayscale-[0.5] !w-[315px] !h-[415px]" />
                  
                  {}
                  <div className="absolute inset-0 bg-primary/10 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />

                  {}
                  <div className="absolute inset-x-0 bottom-0 flex translate-y-full flex-col items-start gap-3 border-t border-white/10 bg-primary/60 p-6 backdrop-blur-md transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:translate-y-0">
                    <Badge variant="secondary" className="border-none bg-secondary text-secondary-foreground font-default uppercase tracking-wider">
                      {project.industry}
                    </Badge>
                    <h3 className="font-default text-2xl font-bold text-white">
                      {project.title}
                    </h3>
                  </div>
                </AspectRatio>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}